import { runIsolatedJob2ho1zf4fsdg8q as runIsolatedJob } from './runIsolatedJob.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createCleanupCallback(block) {
  return () => runIsolatedJob(block);
}
//region block: exports
export {
  createCleanupCallback as createCleanupCallback20ojlqmkr3oia,
};
//endregion

//# sourceMappingURL=createCleanupCallback.mjs.map
